import Moment from 'moment';

export function toIsoDateValue(value) {
  if (!value) return '';
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? '' : value.toISOString().slice(0, 10);
  }
  const date = Moment(value);
  return date.isValid() ? date.format('YYYY-MM-DD') : '';
}

export function getAge(dateOrDateString) {
  const now = Moment();
  let dob;
  if (!dateOrDateString) {
    return null;
  }
  if (typeof dateOrDateString === 'string') {
    dob = Moment(dateOrDateString);
  } else {
    dob = dateOrDateString;
  } /* may be a Moment obj */
  return now.diff(dob, 'years');
}

/**
 * Traveler date ranges that must stay inside the policy dates.
 * To bound a new range, add an entry:
 *   enabledKey - traveler flag that turns the range on
 *   rangeKey   - traveler field holding the range object
 *   startKey / endKey - fields inside the range object
 */
export const POLICY_BOUND_DATE_RANGES = [
  {enabledKey: 'needDateExtremeSport', rangeKey: 'dateExtremeSportRange', startKey: 'startDateExtremeSport', endKey: 'endDateExtremeSport'},
  {enabledKey: 'needDateWinterSport', rangeKey: 'dateWinterSportRange', startKey: 'startDateWinterSport', endKey: 'endDateWinterSport'},
];

// same format the date pickers store (see convertToUTCDate in Tab4 / RidersList)
const toUTCNoon = momentDate =>
  new Date(Date.UTC(momentDate.year(), momentDate.month(), momentDate.date(), 12, 0, 0));

/**
 * Keeps each traveler's POLICY_BOUND_DATE_RANGES inside the policy dates.
 * Needed because the ranges are only defaulted when empty, so changing the policy
 * dates afterwards (e.g. after QUOTE_EXPIRED at midnight) leaves them stale.
 * Dates already inside the policy are kept as the customer chose them.
 */
export function clampDateRangesToPolicy(travelers, policyStartDate, policyEndDate) {
  if (!Array.isArray(travelers) || !policyStartDate || !policyEndDate) {
    return travelers;
  }
  const policyStart = Moment(policyStartDate);
  const policyEnd = Moment(policyEndDate);
  if (!policyStart.isValid() || !policyEnd.isValid()) {
    return travelers;
  }
  const isOutOfPolicy = date =>
    !date.isValid() || date.isBefore(policyStart, 'day') || date.isAfter(policyEnd, 'day');

  return travelers.map(traveler => {
    if (!traveler) {
      return traveler;
    }
    const clamped = {...traveler};
    POLICY_BOUND_DATE_RANGES.forEach(({enabledKey, rangeKey, startKey, endKey}) => {
      const range = traveler[rangeKey];
      if (!traveler[enabledKey] || !range) {
        return;
      }
      let start = Moment(range[startKey]);
      let end = Moment(range[endKey]);
      if (isOutOfPolicy(start)) {
        start = policyStart;
      }
      if (isOutOfPolicy(end)) {
        end = policyEnd;
      }
      if (start.isAfter(end, 'day')) {
        start = policyStart;
        end = policyEnd;
      }
      clamped[rangeKey] = {...range, [startKey]: toUTCNoon(start), [endKey]: toUTCNoon(end)};
    });
    return clamped;
  });
}
